/**
 * [Pure] Turn file into encodedBinary.
 * @param file - File to turn into binary.
 */
export async function readFileAsync(file: any): Promise<any> {
    return new Promise((resolve, reject) => {                                                   // Return promise (async).
        let reader = new FileReader();                                                          // Initialize file reader.
        reader.onloadend = (e: any) => {                                                        // Listen for reader loaded event:
            const bytes = new Uint8Array(e.target.result);                                      // Get bytes from file.
            let binary = '';                                                                    // Initialize binary string.
            for (var j = 0; j < bytes.byteLength; j++) binary += String.fromCharCode(bytes[j]); // Add data to binary.
            resolve(btoa(binary));                                                              // Resolve promise with binary.
        }
        reader.readAsArrayBuffer(file);                                                         // Send file to reader.
    });
}
